import { __rest } from "tslib";
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';
export var isQRCodeValue = function (valueOrOptions) {
    return typeof valueOrOptions === 'string' || Array.isArray(valueOrOptions);
};
export var useQRCode = function (valueOrOptions) {
    var _a = useState(), dataURL = _a[0], setDataURL = _a[1];
    useEffect(function () {
        var isValue = isQRCodeValue(valueOrOptions);
        var value = (isValue
            ? valueOrOptions
            : valueOrOptions.value);
        var options;
        if (!isValue) {
            var _a = valueOrOptions, quality = _a.quality, props = __rest(_a, ["quality"]);
            options = Object.assign(props, {
                renderOptions: {
                    quality: quality,
                },
            });
        }
        if (!value) {
            return setDataURL(undefined);
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        QRCode.toDataURL(value, options).then(setDataURL);
    }, [valueOrOptions]);
    return dataURL;
};
//# sourceMappingURL=use-qrcode.js.map